export default __webpack_public_path__ + "static/media/flor3.3389bfa7.jpeg";